const scrollToAnchor = {
  position: "relative",
  top: "-150px",
};

export { scrollToAnchor };
